import enLocale from '@/locale/en';

const config = {
    inject: false,
    fieldsBagName: 'inputs',
    events: 'onsubmit',
    dictionary: {
        en: enLocale.validation,
    },
};

export default config;
